import type { CSSObject } from '@emotion/react'
import type { FC } from 'react'
import { useState } from 'react'
import { useIsWideScreen } from 'utils/useIsWideScreen'
import { NarrowScreenPanel } from './NarrowScreenPanel'
import { WideScreenPanel } from './WideScreenPanel'

type MapControlsPanelProps = {
  children?: React.ReactNode
  expandedContent?: React.ReactNode
  isPropertyPlaybackActive?: boolean
  style?: React.CSSProperties | CSSObject
}

export const MapControlsPanel: FC<MapControlsPanelProps> = ({
  children,
  expandedContent,
  isPropertyPlaybackActive,
  style: panelStyle,
}) => {
  const isWideScreen = useIsWideScreen()
  const [isExpanded, setIsExpanded] = useState(true)

  return isWideScreen ? (
    <WideScreenPanel
      expandedContent={expandedContent}
      isExpanded={isPropertyPlaybackActive ? !isExpanded : isExpanded}
      setIsExpanded={setIsExpanded}
      style={panelStyle}
    >
      {children}
    </WideScreenPanel>
  ) : (
    <NarrowScreenPanel
      expandedContent={expandedContent}
      isExpanded={isPropertyPlaybackActive ? !isExpanded : isExpanded}
      setIsExpanded={setIsExpanded}
      style={panelStyle}
    >
      {children}
    </NarrowScreenPanel>
  )
}
